

// import { X, Save, MapPin } from 'lucide-react';

// import { useUpdateTour } from '../hooks/useUpdateTour';

// import { useState, useEffect } from 'react';

// import {

//   useUploadTourVideo

// }

//   from

//   '../hooks/useUploadTourVideo';



// export const EditTourModal = (props) => {

//   const { isEditModalOpen, setIsEditModalOpen, tour } = props;

//   const {

//     mutate: updateTour,

//     isPending

//   }

//     =

//     useUpdateTour();





//   const uploadVideoMutation =

//     useUploadTourVideo();

//     const uploadImageMutation =
//   useUploadTourVideo();



//   const [formData, setFormData] = useState({

//     approvalStatus: '',



//     isActive: false,



//     isPopular: false,



//     isFeatured: false,



//     rejectionReason: '',



//     videos: [],

//       images: [],


//   });


//   const [
//  videoFiles,
//  setVideoFiles
// ]
// =
// useState([]);



// const [imageFiles, setImageFiles] = useState([]);


//   useEffect(() => {

//     if (tour) {

//       setFormData({

//         approvalStatus: tour.approvalStatus || 'pending',

//         isActive: tour.isActive || false,

//         isPopular: tour.isPopular || false,

//         isFeatured: tour.isFeatured || false,

//         rejectionReason:

//           tour.rejectionReason || '',



//         videos:

//           tour.videos || [],

//       });

      





//     }

//   }, [tour]);



//   const handleSubmit = (e) => {

//     e.preventDefault();



//     const payload = {

//       approvalStatus: formData.approvalStatus,

//       isActive: formData.isActive,

//       isPopular: formData.isPopular,

//       isFeatured: formData.isFeatured,

//       videos:

//         formData.videos,

//     };



//     // Only include rejection reason if status is rejected

//     if (formData.approvalStatus === 'rejected' && formData.rejectionReason) {

//       payload.rejectionReason = formData.rejectionReason;

//     }



//     updateTour(

//       {

//         tourId: tour._id,

//         data: payload,

//       },

//       {

//         onSuccess: () => {

//           setIsEditModalOpen(false);

//         },

//       }

//     );

//   };



//   const handleChange = (e) => {

//     const { name, value, type, checked } = e.target;

//     setFormData((prev) => ({

//       ...prev,

//       [name]: type === 'checkbox' ? checked : value,

//     }));

//   };



//   if (!isEditModalOpen || !tour) return null;



//   // Check if approval status can be changed (only pending status can be changed)

//   const isApprovalLocked = tour.approvalStatus !== 'pending';



//   return (

//     <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>

//       <div className='bg-card border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto custom-scrollbar'>

//         {/* Header */}

//         <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>

//           <div className='flex items-center space-x-3'>

//             <div className='p-2 bg-primary/10 rounded-lg'>

//               <MapPin size={20} className='text-primary' />

//             </div>

//             <div>

//               <h2 className='text-lg font-semibold'>Edit Tour Package</h2>

//               <p className='text-xs text-muted-foreground'>{tour.title}</p>

//             </div>

//           </div>

//           <button

//             onClick={() => setIsEditModalOpen(false)}

//             className='p-1 hover:bg-muted rounded-md transition-colors'

//           >

//             <X size={20} />

//           </button>

//         </div>



//         {/* Form */}

//         <form onSubmit={handleSubmit} className='p-6 space-y-6'>

//           {/* Tour Info (Read-only) */}

//           <div className='bg-muted rounded-lg p-4'>

//             <h3 className='text-sm font-medium mb-3'>Tour Information</h3>

//             <div className='grid grid-cols-2 gap-3 text-sm'>

//               <div>

//                 <span className='text-muted-foreground'>Destination:</span>

//                 <span className='ml-2 font-medium'>{tour.destination}</span>

//               </div>

//               <div>

//                 <span className='text-muted-foreground'>Duration:</span>

//                 <span className='ml-2 font-medium'>

//                   {tour.duration} {tour.duration === 1 ? 'day' : 'days'}

//                 </span>

//               </div>

//               <div>

//                 <span className='text-muted-foreground'>Type:</span>

//                 <span className='ml-2 font-medium capitalize'>{tour.tourType}</span>

//               </div>

//               <div>

//                 <span className='text-muted-foreground'>Price:</span>

//                 <span className='ml-2 font-medium'>

//                   {tour.pricing?.currency || 'INR'} {tour.pricing?.basePrice?.toFixed(2)}

//                 </span>

//               </div>

//             </div>

//           </div>





//           {/* Tour Info (Read-only) */}

//           <div className='bg-muted rounded-lg p-4'>

//             ...

//           </div>



//           {/* Approval Status */}

//           {/* <div className='space-y-2'>

//             <label className='text-sm font-medium'>Approval Status</label>



//             {isApprovalLocked ? (

//               <div className='px-3 py-2 border border-border rounded-md bg-muted text-sm capitalize'>

//                 {formData.approvalStatus}

//               </div>

//             ) : (

//               <select

//                 name='approvalStatus'

//                 value={formData.approvalStatus}

//                 onChange={handleChange}

//                 className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'

//               >

//                 <option value='pending'>Pending</option>

//                 <option value='approved'>Approved</option>

//                 <option value='rejected'>Rejected</option>

//               </select>

//             )}

//           </div> */}





//           {/* VIDEOS */}



//           <div className='space-y-2'>

              

//             <label className='text-sm font-medium'>

//               Videos

//             </label>

//             <div className='space-y-3'>

// <label
//  className='text-sm font-medium'
// >

// Videos

// </label>



//               <input

//                 type='file'

//                 accept='video/*'

//                 multiple


//                 onChange={(e) => {

//                   setVideoFiles(

//                     Array.from(
//                       e.target.files
//                     )

//                   );

//                 }}

//               />


// {
//  formData.videos?.length > 0 && (

//    <div
//    className='space-y-2'
//    >

//      {
//  formData.videos?.length > 0 && (

//   <div className='space-y-4'>

//    {

//     formData.videos.map(

//       (
//         video,
//         i
//       )=>(


// <div
//  key={i}
//  className='border rounded-lg p-3 space-y-2'
// >


// <video

//  src={video}

//  controls

//  className='w-full rounded'

// />



// <button

//  type='button'


//  onClick={()=>{

//    setFormData(

//      prev=>({

//        ...prev,


//        videos:

//        prev.videos.filter(

//           (

//             _,

//             index

//           )=>

//           index!==i

//        )



//      })

//    );

//  }}



//  className='

//  px-3

//  py-1

//  text-sm

//  bg-red-500

//  text-white

//  rounded

//  '

// >

// Remove Video

// </button>


// </div>


// )

// )

// }

// </div>

// )
// }

//    </div>

//  )
// }



// <button

//  type='button'


//  disabled={

//  uploadVideoMutation
//  .isPending ||

//  !videoFiles.length

//  }


//  onClick={async()=>{

//  let uploaded =

//  [...formData.videos];


//  for(

//    const file

//    of videoFiles

//  ){

//    const res =

//    await uploadVideoMutation
//    .mutateAsync(
//       file
//    );


//    uploaded.push(

//       res.data.url

//    );

//  }



//  setFormData(

//    prev=>({

//       ...prev,

//       videos:

//       uploaded

//    })

//  );



//  setVideoFiles([]);

//  }}



//  className='
//  px-4
//  py-2
//  bg-primary
//  text-white
//  rounded-lg
//  '

// >

// {

// uploadVideoMutation
// .isPending

// ?

// 'Uploading...'

// :

// 'Upload Videos'

// }


// </button>

// </div>


//             {/* <p className='text-xs text-muted-foreground'>

//               Add one video URL per line

//             </p> */}



//           </div>





//           {/* Rejection Reason (shown when rejected) */}

//           {formData.approvalStatus === 'rejected' && (

//             <div className='space-y-2'>

//               <label className='text-sm font-medium'>Rejection Reason</label>

//               {isApprovalLocked ? (

//                 <div className='w-full px-3 py-2 text-sm border border-border rounded-md bg-muted'>

//                   <p className='whitespace-pre-wrap'>{tour.rejectionReason || 'No reason provided'}</p>

//                 </div>

//               ) : (

//                 <textarea

//                   name='rejectionReason'

//                   value={formData.rejectionReason}

//                   onChange={handleChange}

//                   rows={4}

//                   className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'

//                   placeholder='Provide a reason for rejection...'

//                 />

//               )}

//               <p className='text-xs text-muted-foreground'>

//                 {isApprovalLocked

//                   ? 'This reason was provided when the tour was rejected'

//                   : 'This reason will be visible to the seller'}

//               </p>

//             </div>

//           )}



//           {/* Status Toggles */}

//           {/* <div className='space-y-4'>

//             <label className='text-sm font-medium'>Status & Flags</label>



      

//             <div className='flex items-center justify-between p-3 bg-muted rounded-lg'>

//               <div>

//                 <p className='text-sm font-medium'>Active Status</p>

//                 <p className='text-xs text-muted-foreground'>Make tour visible to customers</p>

//               </div>

//               <label className='relative inline-flex items-center cursor-pointer'>

//                 <input

//                   type='checkbox'

//                   name='isActive'

//                   checked={formData.isActive}

//                   onChange={handleChange}

//                   className='sr-only peer'

//                 />

//                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>

//               </label>

//             </div>



   

//             <div className='flex items-center justify-between p-3 bg-muted rounded-lg'>

//               <div>

//                 <p className='text-sm font-medium'>Popular</p>

//                 <p className='text-xs text-muted-foreground'>Mark as popular tour</p>

//               </div>

//               <label className='relative inline-flex items-center cursor-pointer'>

//                 <input

//                   type='checkbox'

//                   name='isPopular'

//                   checked={formData.isPopular}

//                   onChange={handleChange}

//                   className='sr-only peer'

//                 />

//                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>

//               </label>

//             </div>




//             <div className='flex items-center justify-between p-3 bg-muted rounded-lg'>

//               <div>

//                 <p className='text-sm font-medium'>Featured</p>

//                 <p className='text-xs text-muted-foreground'>Feature this tour on homepage</p>

//               </div>

//               <label className='relative inline-flex items-center cursor-pointer'>

//                 <input

//                   type='checkbox'

//                   name='isFeatured'

//                   checked={formData.isFeatured}

//                   onChange={handleChange}

//                   className='sr-only peer'

//                 />

//                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>

//               </label>

//             </div>

//           </div> */}



//           {/* Footer */}

//           <div className='flex justify-end space-x-3 pt-4 border-t border-border'>

//             <button

//               type='button'

//               onClick={() => setIsEditModalOpen(false)}

//               className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'

//               disabled={isPending}

//             >

//               Cancel

//             </button>

//             <button

//               type='submit'

//               disabled={isPending}

//               className='flex items-center space-x-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'

//             >

//               <Save size={16} />

//               <span>{isPending ? 'Saving...' : 'Save Changes'}</span>

//             </button>

//           </div>

//         </form>

//       </div>

//     </div>

//   );

// };





import { X, Save, MapPin } from 'lucide-react';
import { useUpdateTour } from '../hooks/useUpdateTour';
import { useState, useEffect } from 'react';
import { useUploadTourVideo } from '../hooks/useUploadTourVideo';

export const EditTourModal = (props) => {
  const { isEditModalOpen, setIsEditModalOpen, tour } = props;
  const { mutate: updateTour, isPending } = useUpdateTour();

  const uploadVideoMutation = useUploadTourVideo();
  const uploadImageMutation = useUploadTourVideo();

  const [formData, setFormData] = useState({
    approvalStatus: '',
    isActive: false,
    isPopular: false,
    isFeatured: false,
    rejectionReason: '',
    // Each video: { key: string, preSignedUrl: string }
    videos: [],
    // Each image: { key: string, preSignedUrl: string }
    images: [],
  });

  const [videoFiles, setVideoFiles] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);

  useEffect(() => {
    if (tour) {
      setFormData({
        approvalStatus: tour.approvalStatus || 'pending',
        isActive: tour.isActive || false,
        isPopular: tour.isPopular || false,
        isFeatured: tour.isFeatured || false,
        rejectionReason: tour.rejectionReason || '',

        // Normalize existing videos — support plain strings and objects, skip nulls
        videos: (tour.videos || [])
          .filter((v) => v != null)
          .map((v) => {
            if (typeof v === 'string') return { key: v, preSignedUrl: v };
            const key = v.key || v.url;
            return { key, preSignedUrl: v.preSignedUrl || v.presignedUrl || key };
          }),

        // Normalize existing images — support plain strings and objects, skip nulls
        images: (tour.images || [])
          .filter((img) => img != null)
          .map((img) => {
            if (typeof img === 'string') return { key: img, preSignedUrl: img };
            const key = img.key || img.url;
            return { key, preSignedUrl: img.preSignedUrl || img.presignedUrl || key };
          }),
      });
    }
  }, [tour]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      approvalStatus: formData.approvalStatus,
      isActive: formData.isActive,
      isPopular: formData.isPopular,
      isFeatured: formData.isFeatured,
      // Send only keys to DB
      videos: formData.videos.map((v) => v.key),
      images: formData.images.map((img) => ({ url: img.key })),
    };

    if (formData.approvalStatus === 'rejected' && formData.rejectionReason) {
      payload.rejectionReason = formData.rejectionReason;
    }

    updateTour(
      { tourId: tour._id, data: payload },
      {
        onSuccess: () => {
          setIsEditModalOpen(false);
        },
      }
    );
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  if (!isEditModalOpen || !tour) return null;

  const isApprovalLocked = tour.approvalStatus !== 'pending';

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto custom-scrollbar'>

        {/* Header */}
        <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>
          <div className='flex items-center space-x-3'>
            <div className='p-2 bg-primary/10 rounded-lg'>
              <MapPin size={20} className='text-primary' />
            </div>
            <div>
              <h2 className='text-lg font-semibold'>Edit Tour Package</h2>
              <p className='text-xs text-muted-foreground'>{tour.title}</p>
            </div>
          </div>
          <button
            onClick={() => setIsEditModalOpen(false)}
            className='p-1 hover:bg-muted rounded-md transition-colors'
          >
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className='p-6 space-y-6'>

          {/* Tour Info (Read-only) */}
          <div className='bg-muted rounded-lg p-4'>
            <h3 className='text-sm font-medium mb-3'>Tour Information</h3>
            <div className='grid grid-cols-2 gap-3 text-sm'>
              <div>
                <span className='text-muted-foreground'>Destination:</span>
                <span className='ml-2 font-medium'>{tour.destination}</span>
              </div>
              <div>
                <span className='text-muted-foreground'>Duration:</span>
                <span className='ml-2 font-medium'>
                  {tour.duration} {tour.duration === 1 ? 'day' : 'days'}
                </span>
              </div>
              <div>
                <span className='text-muted-foreground'>Type:</span>
                <span className='ml-2 font-medium capitalize'>{tour.tourType}</span>
              </div>
              <div>
                <span className='text-muted-foreground'>Price:</span>
                <span className='ml-2 font-medium'>
                  {tour.pricing?.currency || 'INR'} {tour.pricing?.basePrice?.toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* IMAGES */}
          <div className='space-y-4'>
            <label className='text-sm font-medium'>Images</label>

            <input
              type='file'
              accept='image/*'
              multiple
              onChange={(e) => setImageFiles(Array.from(e.target.files))}
            />

            {formData.images.length > 0 && (
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                {formData.images.map((image, i) => (
                  <div key={i} className='border rounded-lg p-2'>
                    <img
                      // Use preSignedUrl for preview
                      src={image.preSignedUrl}
                      alt='tour'
                      className='w-full h-32 object-cover rounded'
                    />
                    <button
                      type='button'
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          images: prev.images.filter((_, index) => index !== i),
                        }))
                      }
                      className='w-full mt-2 px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600'
                    >
                      Remove Image
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button
              type='button'
              disabled={uploadImageMutation.isPending || !imageFiles.length}
              onClick={async () => {
                const uploaded = [...formData.images];

                for (const file of imageFiles) {
                  const res = await uploadImageMutation.mutateAsync(file);
                  // Store key (for DB) + preSignedUrl (for preview)
                  uploaded.push({
                    key: res?.data?.key,
                    preSignedUrl: res?.data?.preSignedUrl,
                  });
                }

                setFormData((prev) => ({ ...prev, images: uploaded }));
                setImageFiles([]);
              }}
              className='px-4 py-2 bg-primary text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {uploadImageMutation.isPending ? 'Uploading...' : 'Upload Images'}
            </button>
          </div>


              {/* Approval Status */}
<div className='space-y-2'>
  <label className='text-sm font-medium'>Approval Status</label>

  {isApprovalLocked ? (
    <div className='px-3 py-2 border border-border rounded-md bg-muted text-sm capitalize'>
      {formData.approvalStatus}
    </div>
  ) : (
    <select
      name='approvalStatus'
      value={formData.approvalStatus}
      onChange={handleChange}
      className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
    >
      <option value='pending'>Pending</option>
      <option value='approved'>Approved</option>
      <option value='rejected'>Rejected</option>
    </select>
  )}
</div>
          

          {/* VIDEOS */}
          <div className='space-y-4'>
            <label className='text-sm font-medium'>Videos</label>

            <input
              type='file'
              accept='video/*'
              multiple
              onChange={(e) => setVideoFiles(Array.from(e.target.files))}
            />

            {formData.videos.length > 0 && (
              <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
                {formData.videos.map((video, i) => (
                  <div key={i} className='border rounded-lg p-2'>
                    <video
                      // Use preSignedUrl for preview
                      src={video.preSignedUrl}
                      controls
                      className='w-full h-32 object-cover rounded'
                    />
                    <button
                      type='button'
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          videos: prev.videos.filter((_, index) => index !== i),
                        }))
                      }
                      className='px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600'
                    >
                      Remove Video
                    </button>
                  </div>
                ))}
              </div>
            )}

            <button
              type='button'
              disabled={uploadVideoMutation.isPending || !videoFiles.length}
              onClick={async () => {
                const uploaded = [...formData.videos];

                for (const file of videoFiles) {
                  const res = await uploadVideoMutation.mutateAsync(file);
                  // Store key (for DB) + preSignedUrl (for preview)
                  uploaded.push({
                    key: res?.data?.key,
                    preSignedUrl: res?.data?.preSignedUrl,
                  });
                }

                setFormData((prev) => ({ ...prev, videos: uploaded }));
                setVideoFiles([]);
              }}
              className='px-4 py-2 bg-primary text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {uploadVideoMutation.isPending ? 'Uploading...' : 'Upload Videos'}
            </button>
          </div>

          {/* Rejection Reason (shown when rejected) */}
          {formData.approvalStatus === 'rejected' && (
            <div className='space-y-2'>
              <label className='text-sm font-medium'>Rejection Reason</label>
              {isApprovalLocked ? (
                <div className='w-full px-3 py-2 text-sm border border-border rounded-md bg-muted'>
                  <p className='whitespace-pre-wrap'>
                    {tour.rejectionReason || 'No reason provided'}
                  </p>
                </div>
              ) : (
                <textarea
                  name='rejectionReason'
                  value={formData.rejectionReason}
                  onChange={handleChange}
                  rows={4}
                  className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background'
                  placeholder='Provide a reason for rejection...'
                />
              )}
              <p className='text-xs text-muted-foreground'>
                {isApprovalLocked
                  ? 'This reason was provided when the tour was rejected'
                  : 'This reason will be visible to the seller'}
              </p>
            </div>
          )}

          {/* Footer */}
          <div className='flex justify-end space-x-3 pt-4 border-t border-border'>
            <button
              type='button'
              onClick={() => setIsEditModalOpen(false)}
              className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'
              disabled={isPending}
            >
              Cancel
            </button>
            <button
              type='submit'
              disabled={isPending}
              className='flex items-center space-x-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
            >
              <Save size={16} />
              <span>{isPending ? 'Saving...' : 'Save Changes'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};